module.exports = __webpack_public_path__ + "img/avalia_logo.404d805a.png";